import * as React from "react";
import { WithUserData } from "@grandvisionhq/my-account";
import CancelAppointmentContainer from "./CancelAppointmentContainer.js";
import { withUserToken } from "../../../../../../../../../hoc/v3/hoc/with-user-token.js";
const CancelAppointmentRootWithUserToken = withUserToken(CancelAppointmentContainer);
const CancelAppointmentRootWithUserData = WithUserData(CancelAppointmentRootWithUserToken);
const CancelAppointmentRootWithMyAccountEnabled = ({
  ...props
}) => /* @__PURE__ */ React.createElement(CancelAppointmentRootWithUserData, { ...props, isMyAccountEnabled: true });
export {
  CancelAppointmentRootWithMyAccountEnabled as default
};
//# sourceMappingURL=CancelAppointmentRootWithUserToken.js.map
